module.exports = __webpack_public_path__ + "static/img/listwa_2.8076241.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/urzadzenia/listwa_2.svg
// module id = zeb4
// module chunks = 1